import PropTypes from 'prop-types';
import { BsBank, BsCurrencyEuro, BsGraphUp, BsPeopleFill } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';

import { formatEurCompact, formatNumber } from '../../utils/formatters';
import { buildLatestFinancials } from '../../utils/leadDataTransform';

const KPIS = [
	{ key: 'revenue', label: 'Umsatz', icon: BsCurrencyEuro, format: formatEurCompact },
	{ key: 'earnings', label: 'Gewinn', icon: BsGraphUp, format: formatEurCompact },
	{ key: 'employeeCount', label: 'Mitarbeiter', icon: BsPeopleFill, format: formatNumber },
	{ key: 'balanceTotal', label: 'Bilanzsumme', icon: BsBank, format: formatEurCompact },
];

const KPICard = ({ icon: Icon, label, value, year, isEstimate }) => (
	<Card>
		<div className="mb-2 flex items-center gap-2">
			<div className="flex h-8 w-8 items-center justify-center rounded-control bg-primary-100 text-primary-600">
				<Icon className="h-4 w-4" />
			</div>
			<span className="text-xs font-medium text-bgBase-800">{label}</span>
		</div>
		<div className={`text-lg font-bold ${isEstimate ? 'text-caution-700' : 'text-text'}`}>{value}</div>
		<div className="mt-1 text-xs text-bgBase-800">
			{year ?? '–'}
			{isEstimate && <span className="ml-1 text-caution-700">· Schätzung</span>}
		</div>
	</Card>
);

KPICard.propTypes = {
	icon: PropTypes.elementType.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	year: PropTypes.number,
	isEstimate: PropTypes.bool,
};

const CompanyFinancialKPIs = ({ financials }) => {
	const latest = buildLatestFinancials(financials);
	if (!latest) return null;

	return (
		<div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
			{KPIS.map(({ key, label, icon, format }) => {
				const value = latest[key];
				const hasValue = value !== null && value !== undefined;
				return (
					<KPICard
						key={key}
						icon={icon}
						label={label}
						value={format(value)}
						year={latest[`${key}Year`]}
						isEstimate={hasValue && Boolean(latest[`${key}IsEstimate`])}
					/>
				);
			})}
		</div>
	);
};

CompanyFinancialKPIs.propTypes = {
	financials: PropTypes.array.isRequired,
};

export default CompanyFinancialKPIs;
